import { IQuest } from '../../daily-quests-page.types';
import { QuestCard } from '../quest-card/quest-card';
import { t } from 'i18next';

import SecondaryBtn from 'shared/components/ui/SecondaryBtn/SecondaryBtn';

interface IQuestListProps {
  items: IQuest[];
  onClaim: (id: string) => Promise<boolean>;
  pendingTx?: string | null;
  loading?: boolean;
  onRetry?: () => void;
}

export const QuestList = ({ items, onClaim, pendingTx, onRetry }: IQuestListProps) => {
  if (!items?.length) {
    return (
      <div
        className="mb-4 rounded-2xl border border-white/10 bg-white/5 px-4 py-6 text-center text-lg text-white/80"
        data-testid="quest-empty"
      >
        {t('pages.dailyQuests.noQuests')}
        {onRetry && (
          <div className="mt-6">
            <SecondaryBtn
              text={'pages.dailyQuests.refresh'}
              onClick={onRetry}
              className="mb-6 min-h-8 rounded-3xl"
              childClassName="rounded-3xl text-base py-1.5 min-h-8 leading-4 px-8"
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      {items.map((quest) => (
        <QuestCard key={quest.id} quest={quest} onClaim={onClaim} pendingId={pendingTx} />
      ))}
    </>
  );
};
